import CurrencyFormatter from '@apigrowfinance/pbolt-currency-formatter';

type TwoCurrencyTransactionProps = {
    principalTransaction: {
        value: number;
        currency: string;
    };
    localTransaction: {
        value: number;
        currency: string;
    };
    variant?: 'error' | 'success' | 'default';
    symbol?: 'positive' | 'minus' | 'default';
};

const TwoCurrencyTransaction = ({
    principalTransaction,
    localTransaction,
    variant = 'default',
    symbol = 'default',
}: TwoCurrencyTransactionProps) => {
    return (
        <>
            <CurrencyFormatter
                testId="local-balance"
                amount={localTransaction?.value}
                currency={localTransaction?.currency}
                symbol={symbol}
                variant={variant}
            />
            <span style={{ marginLeft: '5px', fontWeight: 600 }}>(</span>
            <CurrencyFormatter
                testId="principal-balance"
                amount={principalTransaction?.value}
                currency={principalTransaction?.currency}
                symbol={symbol}
                variant={variant}
            />
            <span style={{ fontWeight: 600 }}>)</span>
        </>
    );
};

export default TwoCurrencyTransaction;
